import moment from "moment";
import {
  ABILITIES,
  AUTH_NAMESPACE,
  TEM_NOTIFICACAO,
  USER
} from "store/modules/auth";
const mixin = {
  computed: {
    /**
     * Retorna se o usuário possui notificações pendentes no $store
     */
    $possuiNotificacao() {
      return this.$store.getters[`${AUTH_NAMESPACE}/${TEM_NOTIFICACAO}`]
    },
    /**
    * Retorna o usuário logado salvo no $store
    */
    $user() {
      return {
        ...this.$store.getters[`${AUTH_NAMESPACE}/${USER}`],
        permissions: this.$store.getters[`${AUTH_NAMESPACE}/${ABILITIES}`]
      }
    },
    /**
    * Retorna a propriedade padrão usada em todas as tabelas
    */
    $footerProps() {
      return {
        'items-per-page-options': [5, 10, 15, 25, 50, -1],
      };
    },
    /**
    * Retorna os tipos de condição usados no SIGFOCO
    */
    $tipoCondicaoOptions() {
      return [
        { descricao: 'Discente', value: 'discente' },
        { descricao: 'Docente', value: 'docente' },
      ]
    },
    $tiposAnexos() {
      return [
        { descricao: 'PDF', value: 'PDF' },
        { descricao: 'DOCX', value: 'DOCX' },
        { descricao: 'PNG', value: 'PNG' },
        { descricao: 'JPEG', value: 'JPEG' },
        { descricao: 'MP3', value: 'MP3' },
        { descricao: 'MP4', value: 'MP4' },
        { descricao: 'ZIP', value: 'ZIP' },
      ]
    },
    /**
    * Retorna a data/hora de hoje formatada
    */
    $hoje() {
      return new Date().toLocaleDateString()
    },
    $buildDev() {
      return this.$configurations.env.nodeEnv == "development"
    },
    $recaptchaDev() {
      return this.$configurations.env.recaptcha == "development";
    }
  },
  methods: {
    /**
    * Redireciona para a página home
    * @param app Opcional - path home a ser redirecionado
    */
    $toHome(app = "/app") {
      this.$router.push({ path: app });
    },
    /**
    * Retorna uma página no histórico
    */
    $back() {
      this.$router.go(-1);
    },
    /**
    * Reseta o form padrão ref="form" e o captcha caso exista
    * @param form Opcional - Referência da tag form em tela
    */
    $resetForm(form) {
      form ? form.reset() : this.$refs.form.reset();
      this.$refs.recaptcha && this.$refs.recaptcha.onCaptchaExpired();
    },
    /**
    * Valida o formulário mostrando a mensagem caso inválido
    * @param msg Opcional - Mensagem de campos obrigatórios
    */
    $validarFormulario(msg = "Preencha os campos obrigatórios!") {
      return this.$refs.form.validate()
        ? true
        : this.$notifyWarning(msg)
    },
    /**
    * Converte um base64 em um new File()
    * @param base64 String de base64
    * @param filename Nome do arquivo gerado
    * @param mimeType Formato do arquivo
    */
    $convertBase64ToFile(base64, filename, mimeType) {
      return (fetch(`data:${mimeType};base64,${base64}`)
        .then((res) => res.arrayBuffer())
        .then((buf) => new File([buf], filename, { type: mimeType }))
      );
    },
    /**
    * Formata o CPF no formato padrão '###.###.###-##'
    * @param value Valor do CPF a ser formatado
    */
    $formatCpf(cpf) {
      return (cpf || '').replace(/[^\d]/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    },
    /**
    * Verifica se o usuário logado possui alguma permissão de "administrador."
    */
    $isUserAdmin() {
      return this.$user && this.$user.permissions?.some((g) => g.includes('Administrador'));
    },
    /**
    * Retira a máscara do CPF '###.###.###-##' e retorna '###########'
    * @param value Valor do CPF mascarado
    */
    $unMask(value) {
      if (!value) return "";
      const removeChars = [".", "-", "(", ")", " ", "/"];
      return value.split("").filter(s => !removeChars.includes(s)).join("");
    },
    /**
    * Ignora caso o usuário não tenha digitado um número no input
    * usar em conjunto do @keypress="$event"
    * @param evt Evento recebido pelo input
    */
    $isNumber(evt) {
      if (!["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(evt.key)) {
        evt.preventDefault();
      }
    },
    /**
    * Rola a página até o topo
    */
    $scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    /**
    * Formata o date em formato americano para enviar para a api
    * @param data String da data a ser enviada para o back
    * @param hora Opcional - String da Hora em formato 'hh:mm:ss'
    */
    $formatarDateParaEnviar(data, hora = "00:00:00") {
      if (!data) return data;

      if (data && data.includes("/")) {
        const [dia, mes, ano] = data.split("/");
        return `${ano}-${mes}-${dia}T${hora}`;
      } else {
        return `${data}T${hora}`;
      }
    },
    /**
    * Esconde o CPF em tela adicionando # no formato '###.###.000-##'
    * @param value Valor do CPF a ser mascarado
    */
    $esconderCpf(value) {
      return this.$formatCpf(value)
        .split("")
        .map((v, i) => {
          return [8, 9, 10].includes(i) || v.includes(".") || v.includes("-")
            ? v
            : "#";
        })
        .toString()
        .split(",")
        .join("");
    },
    /**
    * Monta os params corretamente enviando null no lugar de 'Todos'.
    * @param filters Objeto contendo os filtros informados em tela Ex: this.form.filters
    */
    $montarParamsFilters(filters) {
      return {
        params: {
          ...filters,
          situacao: filters.situacao == "Todas" ? null : filters.situacao,
          ano: filters.ano == "Todos" ? null : filters.ano,
          semestre: filters.semestre == "Todos" ? null : filters.semestre
        }
      }
    },
    /**
    * Cria um elemento CSV na tela e realiza o download no navegador do usuário.
    * @param bytes Array de bytes retornado pelo back-end
    * @param nomeDoRelatorio Nome do relatório (csv) a ser baixado
    */
    $baixarRelatorioCSV(bytes, nomeDoRelatorio = "relatorio") {
      const getEncodeData = () => encodeURIComponent(`\uFEFF${bytes}`);
      const a = window.document.createElement("a");
      a.setAttribute("href", `data:text/csv; charset=utf-8,${getEncodeData()}`);
      a.setAttribute("download", `${nomeDoRelatorio}-${Date.now()}.csv`);
      a.click();
      this.$notifySuccess("Relatório baixado com sucesso!");
    },
    $base64ToArrayBuffer(data) {
      var bString = window.atob(data);
      var bLength = bString.length;
      var bytes = new Uint8Array(bLength);
      for (var i = 0; i < bLength; i++) {
          var ascii = bString.charCodeAt(i);
          bytes[i] = ascii;
      }
      return bytes;
    },

    $getFileFromBase64(base64, fileName, fileType, extension) {
        const bufferArray = this.$base64ToArrayBuffer(base64);
        const blob = new Blob([bufferArray], { type: fileType });
        return new File([blob], `${fileName}.${extension}`)
    },
    $baixarArquivo(file, nameFile, fileType) {
        const fr = new FileReader();
        fr.readAsDataURL(file);
        const blob = new Blob([file], { type: fileType });
        const objectURL = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectURL;
        link.download = nameFile;
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.$notifySuccess("Relatório baixado com sucesso!");
    },
        /**
     * Remove a máscara do CPF '###.###.###-##' e retorna '###########'
     * @param {string} cpf - Valor do CPF mascarado
     * @returns {string} - CPF sem máscara
     */
    $removeCpfMask(cpf) {
      if (!cpf) return "";
      return cpf.replace(/\D/g, '');
    },
        /**
    * Retorna a data/hora formatada
    */
    $formatarDataHora(value) {
      if (!value) {
        return '';
      }
    
      try {
        return moment(value).format('DD/MM/YYYY HH:mm:ss');
      } catch {
        console.warn('Data/Hora inválida: ', value);
        return '';
      }
    },
    $formatarData(value) {
      if (!value) {
        return '';
      }
    
      try {
        return moment(value).format('DD/MM/YYYY');
      } catch {
        console.warn('Data/Hora inválida: ', value);
        return '';
      }
    },
    $getParamsObject(params) {
      return { ...params, responseType: "blob" }
    },
    $formatarTelefone(telefone) {
      const cleaned = ('' + telefone).replace(/\D/g, '');
      const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
      if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
      }
      return telefone;
    },
    $validarCPFs(cpf) {
      cpf = cpf.replace(/\D/g, ''); // Remove caracteres não numéricos
      if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
        return false; // Verifica se o CPF tem 11 dígitos e não é uma sequência repetida
      }

      let soma = 0;
      let resto;

      // Validação do primeiro dígito verificador
      for (let i = 1; i <= 9; i++) {
        soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
      }
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.substring(9, 10))) {
        return false;
      }

      soma = 0;

      // Validação do segundo dígito verificador
      for (let i = 1; i <= 10; i++) {
        soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
      }
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.substring(10, 11))) {
        return false;
      }

      return true;
    },
    $validarDDD(telefone) {
      const dddValidos = [
          '11', '12', '13', '14', '15', '16', '17', '18', '19', // São Paulo
          '21', '22', '24', // Rio de Janeiro
          '27', '28', // Espírito Santo
          '31', '32', '33', '34', '35', '37', '38', // Minas Gerais
          '41', '42', '43', '44', '45', '46', // Paraná
          '47', '48', '49', // Santa Catarina
          '51', '53', '54', '55', // Rio Grande do Sul
          '61', // Distrito Federal
          '62', '64', // Goiás
          '63', // Tocantins
          '65', '66', // Mato Grosso
          '67', // Mato Grosso do Sul
          '68', // Acre
          '69', // Rondônia
          '71', '73', '74', '75', '77', // Bahia
          '79', // Sergipe
          '81', '87', // Pernambuco
          '82', // Alagoas
          '83', // Paraíba
          '84', // Rio Grande do Norte
          '85', '88', // Ceará
          '86', '89', // Piauí
          '91', '93', '94', // Pará
          '92', '97', // Amazonas
          '95', // Roraima
          '96', // Amapá
          '98', '99' // Maranhão
      ];
      const cleaned = telefone?.replace(/\D/g, '');
      const ddd = cleaned?.substring(0, 2);
      if (!dddValidos.includes(ddd)) {
        return 'DDD inválido';
      }
      return true;
    },
    $validarCpf(cpf) {
      if (!cpf) return 'Campo obrigatório';

      cpf = cpf.replace(/\D/g, '');
      
      const sequenciasInvalidas = [
        '00000000000',
        '11111111111',
        '22222222222',
        '33333333333',
        '44444444444',
        '55555555555',
        '66666666666',
        '77777777777',
        '88888888888',
        '99999999999'
      ];
      if (sequenciasInvalidas.includes(cpf)) return 'CPF inválido.';
      
      return true;
    },
    $isUserInterno() {
      return this.$user.usuarioTipo === 'interno';
    },
    $validarEntradaNumerica(event) {
      const char = String.fromCharCode(event.keyCode);
      if (!/^\d$/.test(char)) {
        event.preventDefault();
      }
    },
    $validarEntradaNumericaComVirgula(event) {
      const char = String.fromCharCode(event.keyCode);
      const inputValue = event.target.value;
      if ((!/^\d$/.test(char) && char !== ',') || (char === ',' && inputValue.includes(','))) {
      event.preventDefault();
      }
    },
    $validarCPF(cpf, msg = "CPF inválido") {
      // Função para validar CPF
      cpf = cpf.replace(/[^\d]+/g, '');
      if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return msg;
      let soma = 0, resto;
      for (let i = 1; i <= 9; i++) soma += parseInt(cpf.substring(i-1, i)) * (11 - i);
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.substring(9, 10))) return msg;
      soma = 0;
      for (let i = 1; i <= 10; i++) soma += parseInt(cpf.substring(i-1, i)) * (12 - i);
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.substring(10, 11))) return msg;
      return true;
    }   
  },
};
export default mixin;